module.exports = __webpack_public_path__ + "static/media/m25.264da489.webp";